// @flow
import React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';
import DashboardMetricTypeSelector from './DashboardMetricTypeSelector';
import { type MetricType } from '../../../domain/DashboardData';

const Title = styled.h2`
  margin-right: ${({ theme }) => theme.V3.metrics.margin.normal}px !important;
`;

interface Props {
  metricType: MetricType;
  onChange: (metricType: MetricType) => void;
  t: any;
}

function AudienceComparisonHeader({ metricType, onChange, t }: Props) {
  return (
    <React.Fragment>
      <Title>{t('audienceComparative')}</Title>
      <DashboardMetricTypeSelector onChange={onChange} value={metricType} />
    </React.Fragment>
  );
}

export default translate('dashboard')(AudienceComparisonHeader);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/audienceComparison/AudienceComparisonHeader.js